
const API_RESP_MESSAGE = (code: number) => {
    switch (code) {
        case 404:
            return "INVALID CREDENTIALS"
        default:
            return "INVALID CREDENTIALS"
    }
}

export {
    API_RESP_MESSAGE
};
